import { render } from "./MyPageIdentityVerification.vue?vue&type=template&id=487bc307&scoped=true&ts=true"
import script from "./MyPageIdentityVerification.vue?vue&type=script&lang=ts"
export * from "./MyPageIdentityVerification.vue?vue&type=script&lang=ts"

import "./MyPageIdentityVerification.vue?vue&type=style&index=0&id=487bc307&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487bc307"]])

export default __exports__